import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { StyledMapProviderCardList } from './styles';
import { getProviderUrl } from 'Src/provider/utils';
import { getRelativeParameterizedBookingUrl } from 'Src/utils/getRelativeParameterizedBookingUrl';

const ProviderOverlay = ({
  providers,
  position,
  mapContainer,
  locationId,
  location,
  match,
  config,
  searchSummary,
  onBookAppointment,
  onEscape,
  onViewProvider
}) => {
  const [adjustedPosition, setAdjustedPosition] = useState(position);
  const [visible, setVisible] = useState(false);
  const [providersList, setProvidersList] = useState([]);

  useEffect(() => {
    if (mapContainer) {
      setVisible(true);

      const adjustedX = 16;
      const adjustedY = 16;

      setAdjustedPosition({ x: adjustedX, y: adjustedY });
    }
  }, [mapContainer]);

  useEffect(() => {
    const getProvidersForLocation = (providersList, locationId) => {
      if (!providersList || !locationId) return [];

      return providersList
        .filter(
          (provider) =>
            provider &&
            provider.locations &&
            provider.locations.some(
              (locationNew) => locationNew?.id === locationId
            )
        )
        .map((data) => {
          const bookOnlineUrl = getRelativeParameterizedBookingUrl({
            provider: data,
            config,
            location,
            searchSummary
          });

          return {
            provider: {
              id: data.id,
              contact: data.contacts,
              degrees: data.degrees,
              gender: data.gender,
              image_url: data.image_url,
              name: data.name,
              specialties: data.specialties
            },
            providerReviews: {
              ...data.reviews
            },
            viewProviderUrl: getProviderUrl({
              provider: data,
              location,
              match
            }),
            onViewProvider: onViewProvider,
            onBookAppointment: onBookAppointment,
            bookOnlineUrl
          };
        });
    };

    const providersList = getProvidersForLocation(providers, locationId);

    setProvidersList(providersList);
  }, [
    locationId,
    providers,
    location,
    match,
    config,
    searchSummary,
    onBookAppointment
  ]);

  if (!adjustedPosition || !mapContainer.current) return null;

  return createPortal(
    <StyledMapProviderCardList
      providers={providersList}
      data-testid={'map-provider-card-list'}
      style={{
        opacity: visible ? 1 : 0
      }}
      onEscape={onEscape}
    />,
    mapContainer.current
  );
};

ProviderOverlay.propTypes = {
  providers: PropTypes.array,
  locationId: PropTypes.string,
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),
  mapContainer: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  config: PropTypes.object,
  searchSummary: PropTypes.object,
  onBookAppointment: PropTypes.func,
  onEscape: PropTypes.func,
  onViewProvider: PropTypes.func
};

export default ProviderOverlay;
